import { VSelect } from 'vuetify/lib/components/VSelect';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VSelect,{attrs:{"items":_vm.items,"label":_vm.$t('Price type'),"outlined":"","hide-details":"auto"},model:{value:(_vm.priceType),callback:function ($$v) {_vm.priceType=$$v},expression:"priceType"}})}
var staticRenderFns = []

export { render, staticRenderFns }